import { axios } from '@/utils/request'

export function bindWechat (openId) {
  return axios({
    url: '/api-user/users/wechat-bind?openId=' + openId,
    method: 'get'
  })
}
